// Shared `common.*` i18n keys (used across multiple views and the router meta).
// `common.cancel` / `common.create` / `common.update` / `common.delete` are reused
// in form buttons and confirm dialogs. `common.actions` is the table-column header
// for action columns. `common.settings` / `common.details` / `common.users` /
// `common.companies` / `common.roles` are resolved dynamically from `route.meta`
// breadcrumb strings (router.ts), so the keys must remain flat.

export const commonDict: Record<string, [en: string, th: string]> = {
  "common.cancel": ["Cancel", "ยกเลิก"],
  "common.create": ["Create", "สร้าง"],
  "common.delete": ["Delete", "ลบ"],
  "common.update": ["Update", "บันทึก"],
  "common.actions": ["Actions", "จัดการ"],
  "common.error": ["Error", "เกิดข้อผิดพลาด"],
  "common.success": ["Success", "สำเร็จ"],
  "common.operationFailed": ["Operation failed", "ทำรายการไม่สำเร็จ"],
  "common.settings": ["Settings", "ตั้งค่า"],
  "common.details": ["Details", "รายละเอียด"],
  "common.users": ["Users", "ผู้ใช้"],
  "common.companies": ["Companies", "บริษัท"],
  "common.roles": ["Roles", "บทบาท"],
};
